import { LightAlert } from 'components/shared/LightAlert';
import { useAppSelector } from 'hooks/useAppSelector';
import type { IntlKey } from 'locales';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { getCouponsErrors } from 'state/advisory/basket-optimizer/selectors';
import type { IError } from 'utils/errors/spErrors';

const useGetFormattedErrors = (errors: Readonly<IDictionary<IError>>): string[] => {
  const intl = useIntl();
  return Object.entries(errors).map(([key, { errorId, parameters }]) => {
    const label = intl.formatMessage({ id: `label.${key}` as IntlKey, defaultMessage: '' });
    return (
      intl.formatMessage(
        { id: `${'basketOptimizer.underlyings.error.'}${errorId}` as any, defaultMessage: errorId },
        {
          ...parameters,
          label,
        },
      ) || errorId
    );
  });
};

type Props = {
  tabId: string;
};
export function BasketOptimizerUnderlyingsErrors({ tabId }: Props) {
  const errors = useAppSelector(s => getCouponsErrors(s, tabId).fieldErrors);
  const formattedErrors = useGetFormattedErrors(errors);
  return (
    <Fragment>
      {!!formattedErrors.length && (
        <div className="mb-3" data-e2e="basket-optimiser-errors">
          <ul className="list-group ">
            {formattedErrors.map((error, index) => (
              <li className="list-group-item p-0 border-0" key={index}>
                <LightAlert severity="danger">
                  <span data-e2e="basket-optimiser-errors-item">{error}</span>
                </LightAlert>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Fragment>
  );
}
